export { usePagination, generatePageNumbers, ELLIPSIS } from "./use-pagination";
export type {
  UsePaginationProps,
  UsePaginationReturn,
  PageNumber,
} from "./use-pagination";

export { useCursorPagination } from "./use-cursor-pagination";
export type {
  UseCursorPaginationProps,
  UseCursorPaginationReturn,
} from "./use-cursor-pagination";
